import { render, staticRenderFns } from "./Flow.vue?vue&type=template&id=06ed8ebb&scoped=true"
import script from "./Flow.vue?vue&type=script&lang=js"
export * from "./Flow.vue?vue&type=script&lang=js"
import style0 from "./Flow.vue?vue&type=style&index=0&id=06ed8ebb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ed8ebb",
  null
  
)

export default component.exports